import { createSlice } from "@reduxjs/toolkit";

const companyUsersSlice = createSlice({
  name: "companyUsers",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchCompanyUsersRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCompanyUsersSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchCompanyUsersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  }
});

export const {
  fetchCompanyUsersRequest,
  fetchCompanyUsersSuccess,
  fetchCompanyUsersFailure,
} = companyUsersSlice.actions;

export default companyUsersSlice.reducer;